module.exports = {
  IN: '6888 6888',
  LK: '0117777888',
  BG: '16656'
}